import * as lang from 'vuejs-datepicker/src/locale'
/* global $config */

export default {
  config: {
    sysId: 'jcp-stream,',
    sysName: '動画配信',
    region: 'ap-northeast-1',
    loadingImage: 'processing-08',
    pagenationBtnNum: 5, // 3〜15までの奇数(x<3 → 3、x>15 → 15、3≦x≦15の奇数 → x+1)
    calendarFormat: 'yyyy/MM/dd',
    calendarLang: lang.ja,
    authEndpoint: $config.authEndpoint,
    apiGwEndpoint0: $config.apiGwEndpoint0,
    lang: 'jp', // 言語設定
    authorization: {
      mustAuth: false,
      congnitoEnable: false,
      userSignupEnable: false
      // method: 'iam', // API Gatewayの認可(IAMロール: iam、Custom Authorizer: custom_authorizer)
      // identityPoolId: $config.identityPoolId,
      // userPoolId: $config.userPoolId,
      // clientId: $config.clientId,
      // authEndpoint: $config.authorization.authEndpoint,
      // expirationTime: Number.MAX_VALUE, // パスワード有効期限(ミリ秒、3ヶ月 = 7776000000)
      // ttl: 60 * 60 * 1000 // アクセストークンおよびIDトークンの有効期間(ミリ秒、1h以下の値の場合は1hとなる。)
      // accessibleDomain: 'xxxxx.xxx', // Cookieの有効範囲(ドメイン)、サーバサイドの設定に合わせる。サーバサイドでDomain属性を指定しない場合やCookieを使用しない場合は不要
      // accessiblePath: '/' // Cookieの有効範囲(ドメイン)、サーバサイドの設定に合わせる。サーバサイドでDomain属性を指定しない場合やCookieを使用しない場合は不要
    },
    s3Access: {
      contentsBucket: $config.contentsBucket,
      maxUploadSize: 52428800, // S3へアップロードするファイルの最大サイズ
      endpoint: $config.s3Access.endpoint
    }
  }
}
